var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.model.decisionDate
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_c("b", [_vm._v(_vm._s(_vm.decisionDateTitle))])]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2899165543
              )
            },
            [
              _vm._v(" "),
              [
                _vm._v(
                  _vm._s(
                    _vm._f("formatDatetime")(_vm.model.decisionDate, "D.M.YYYY")
                  )
                )
              ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("OrganisationName")))])]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationName))]],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [
                  _c("b", [_vm._v(_vm._s(_vm.$t("Pdf.OrganisationNumber")))])
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v(" "), [_vm._v(_vm._s(_vm.organisationNumber))]],
        2
      ),
      _vm._v(" "),
      _vm.model.record.aidTargetNumber
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _c("b", [_vm._v(_vm._s(_vm.$t("AidTargetNumber")))])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                811736684
              )
            },
            [_vm._v(" "), [_vm._v(_vm._s(_vm.model.record.aidTargetNumber))]],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.model.record.year
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_c("b", [_vm._v(_vm._s(_vm.$t("Year")))])]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1196558621
              )
            },
            [_vm._v(" "), [_vm._v(_vm._s(_vm.model.record.year))]],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.$t("")))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _c("span", {
              staticClass: "preformatted",
              domProps: { innerHTML: _vm._s(_vm.model.purpose) }
            })
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.amountTitle))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _vm._v(
              _vm._s(_vm._f("formatNumber")(_vm.model.refundAmount, 2)) + " €"
            )
          ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.model.refundInterest
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_c("b", [_vm._v(_vm._s(_vm.interestTitle))])]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                296146597
              )
            },
            [
              _vm._v(" "),
              [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.model.refundInterest, 2)) +
                    " €"
                )
              ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.model.refundInterest
        ? _c(
            "text-label-control",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [_c("b", [_vm._v(_vm._s(_vm.totalTitle))])]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4050897921
              )
            },
            [
              _vm._v(" "),
              [
                _vm._v(
                  _vm._s(
                    _vm._f("formatNumber")(_vm.model.refundAmountTotal, 2)
                  ) + " €"
                )
              ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "text-label-control",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function() {
                return [_c("b", [_vm._v(_vm._s(_vm.reasoningTitle))])]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          [
            _c("span", {
              staticClass: "preformatted",
              domProps: { innerHTML: _vm._s(_vm.model.reasoning) }
            })
          ]
        ],
        2
      ),
      _vm._v(" "),
      _c("div", [_c("p", [_vm._v(_vm._s(_vm.notes))])]),
      _vm._v(" "),
      _vm.model.includeInstructions
        ? _c("div", { staticClass: "instructions" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.instructions) } })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }